__turbopack_context__.v({
  "checkbox": "HAQiPq_checkbox",
  "radio": "HAQiPq_radio",
});
